var map = {
	"./img1.jpg": "c1f3",
	"./img2.jpg": "7438",
	"./img3.jpg": "27d5",
	"./img4.jpg": "6463",
	"./img5.jpg": "f795",
	"./img6.jpg": "57cb",
	"./img7.jpg": "da84d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94b2";